
eval("define(\'text!orodatagrid/templates/datagrid/visible-items-counter.html\',[],function () { return \'<%= _.__(\\\'oro.datagrid.pagination.visibleItems\\\', {count: state.length, total: state.totalRecords}) %>\\n\';});\n\n//# sourceURL=/text!orodatagrid/templates/datagrid/visible-items-counter.html");

